export default 'docpadAuthToken'
